import script from "./BaseDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseDialog.vue?vue&type=script&setup=true&lang=js"

import "./BaseDialog.vue?vue&type=style&index=0&id=4eff2cf2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eff2cf2"]])

export default __exports__